
import Vue from "vue";
import moment from "moment";
import eventBus from "@/eventBus";

export default Vue.extend({
  name: "MonthControl",
  props: {
    calendarValue: Object as () => moment.Moment,
  },
  data() {
    return {
      menuOpen: false,
      viewMode: "month" as "month" | "year",
      pickerYear: this.calendarValue
        ? this.calendarValue.year()
        : moment().year(),
    };
  },
  computed: {
    yearList(): number[] {
      const centerYear = this.pickerYear;
      const years: number[] = [];
      for (let i = centerYear - 5; i <= centerYear + 6; i++) {
        years.push(i);
      }
      return years;
    },
  },
  watch: {
    calendarValue(val: moment.Moment) {
      if (val) {
        this.pickerYear = val.year();
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      if (this.menuOpen) {
        this.pickerYear = this.calendarValue
          ? this.calendarValue.year()
          : moment().year();
        this.viewMode = "month";
      }
    },
    closeMenu() {
      this.menuOpen = false;
    },
    handleOutsideClick(e: MouseEvent) {
      const el = this.$refs.monthControlRef as HTMLElement;
      if (el && !el.contains(e.target as Node)) {
        this.closeMenu();
      }
    },
    prevMonth() {
      const prev = this.calendarValue.clone().subtract(1, "month");
      eventBus.$emit("update-calendar", prev);
    },
    nextMonth() {
      const next = this.calendarValue.clone().add(1, "month");
      eventBus.$emit("update-calendar", next);
    },
    changeYear(delta: number) {
      this.pickerYear += delta;
    },
    toggleViewMode() {
      this.viewMode = this.viewMode === "month" ? "year" : "month";
    },
    selectYear(year: number) {
      this.pickerYear = year;
      this.viewMode = "month";
    },
    selectMonth(month: number) {
      const currentDay = this.calendarValue ? this.calendarValue.date() : 1;
      const target = moment([this.pickerYear, month - 1, 1]);
      const maxDaysInTarget = target.daysInMonth();
      const targetDay = Math.min(currentDay, maxDaysInTarget);
      target.date(targetDay);

      eventBus.$emit("update-calendar", target);
      this.closeMenu();
    },
    selectThisMonth() {
      const now = moment();
      eventBus.$emit("update-calendar", now);
      this.closeMenu();
    },
    isSelectedMonth(m: number): boolean {
      if (!this.calendarValue) return false;
      return (
        this.calendarValue.year() === this.pickerYear &&
        this.calendarValue.month() + 1 === m
      );
    },
    isCurrentMonth(m: number): boolean {
      const now = moment();
      return now.year() === this.pickerYear && now.month() + 1 === m;
    },
  },
});
